import { useLoaderData } from '@remix-run/react';
import { PaginatedProjects } from '@modules/professional/component/projects-tab/PaginatedProjects';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';
import type { APHandle } from '~/modules/root';
import type { loader } from '@modules/professional/page/loaders/projects-page-loader.server';

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

export const handle: APHandle = {
    category: 'project',
    excludedQuickSorts: [
        'uncategorised',
        'newlyCreated',
        'invalidLink',
        'highPrice',
        'lowPrice',
        'alphabetical',
        'updated',
    ],
    showViewProjectsByFilters: true,
    disabledInPreview,
    hideContactArchiPro: true,
};

const ProjectsPage = () => {
    const data = useLoaderData<typeof loader>();
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');
    return (
        <PaginatedProjects
            {...data}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default ProjectsPage;
